(function () {
    'use strict';

    function requestForProposalResponseRfpSummaryController(sessionData, rfpResponseData, milestones,
        notifyService, mailRequestDataService, milestoneModalService) {

        var vm = this;
        vm.rfpResponseData = rfpResponseData;
        vm.rfpResponseId = vm.rfpResponseData.Id.split('/')[1];
        vm.sessionData = sessionData;

        vm.contactRespondent = function (entity) {
            mailRequestDataService.sendConnectionRequest({
                RequesterEntityId: sessionData.EntityId,
                RequesteeEntityId: entity.Id
            }).then(function (data) {
                notifyService.notify('We sent a notification to ' + entity.CompanyDetails.Name);
            });
        }

        vm.rfpEntityActions = {
            contactRespondent: {
                label: "Contact",
                call: vm.contactRespondent
            }
        }

        // process rfp content to set permissions and mode
        vm.rfpSummaryMode = 'Display';
        vm.canDeleteInformationPart = false;
        vm.reorderMode = false;

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        vm.hasRequiredDownloads = vm.rfpResponseData.RequestForProposal.RequiredDownloads &&
            vm.rfpResponseData.RequestForProposal.RequiredDownloads.some(function (requiredDownload) {
                return !requiredDownload.IsRemoved;
            });

        vm.noopFunction = function () {
            angular.noop();
        }

        vm.rfpResponseData.RequestForProposal.InformationParts.forEach(function (informationPart) {
            informationPart.Access = {
                View: true,
                Edit: false
            };
            if (informationPart.BlobSummaries) {
                informationPart.BlobSummaries.forEach(function (blob) {
                    blob.Access = {
                        View: true,
                        Edit: false
                    };
                    blob.UploadedByCleanName = blob.UploadedByEntity
                        ? blob.UploadedByEntity.Contact.FirstName + ' ' + blob.UploadedByEntity.Contact.LastName
                        : 'N/A';
                });
            }
        });

        vm.rfpResponseData.RequestForProposal.RequiredDownloads.forEach(function (requiredDownload) {
            // might need something here
        });
    }

    requestForProposalResponseRfpSummaryController.$inject = ['sessionData', 'rfpResponseData', 'milestones',
        'notifyService', 'mailRequestDataService', 'milestoneModalService'];

    angular.module('ecap.requestForProposal').controller('requestForProposalResponseRfpSummaryController', requestForProposalResponseRfpSummaryController);
})();
